module.exports = __webpack_public_path__ + "img/login-cards.69926bd8.png";